/* Raptor Recommendations — client renderer for sections/raptor-recs.liquid.
   Fetches products (native recommendations API on product pages, collection
   JSON otherwise), filters to in-stock items not already in the cart,
   shuffles per visit, renders carousel cards, and adds via /cart/add.js. */
(function () {
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function normalize(p) {
    var variant = null;
    for (var i = 0; i < (p.variants || []).length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    if (!variant || p.available === false) return null;
    var img = p.featured_image || (p.images && p.images[0]) || null;
    if (img && typeof img === 'object') img = img.src || null;
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      productType: p.product_type || p.type || '',
      vendor: p.vendor || '',
      url: p.url || ('/products/' + p.handle),
      image: img,
      variantId: variant.id,
      price: typeof variant.price === 'number' ? variant.price : Math.round(parseFloat(variant.price) * 100),
      compareAt: variant.compare_at_price
        ? (typeof variant.compare_at_price === 'number' ? variant.compare_at_price : Math.round(parseFloat(variant.compare_at_price) * 100))
        : null
    };
  }

  function squareImage(url) {
    if (!url) return null;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=480';
  }

  function fetchJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function fetchCollections(handles, perCollection) {
    var jobs = handles.filter(Boolean).map(function (h) {
      return fetchJSON('/collections/' + encodeURIComponent(h.trim()) + '/products.json?limit=' + perCollection)
        .then(function (d) { return (d && d.products) || []; });
    });
    return Promise.all(jobs).then(function (lists) {
      return [].concat.apply([], lists);
    });
  }

  function init(root) {
    var track = root.querySelector('[data-rr-track]');
    if (!track) return;
    var mode = root.dataset.mode || 'auto';
    var layout = root.dataset.layout || 'carousel';
    var intent = root.dataset.intent || 'related';
    var handles = (root.dataset.collections || '').split(',').filter(Boolean);
    var maxItems = parseInt(root.dataset.maxItems, 10) || 8;
    var productId = root.dataset.productId;
    var showStars = root.dataset.showStars === 'true';
    var showQty = root.dataset.showQty === 'true';

    // Cart first: it powers both the exclude-list and, on the cart page,
    // the recommendation seed (first item) when no product context exists.
    fetchJSON('/cart.js').then(function (cart) {
      var cartItems = (cart && cart.items) || [];
      var seedIds = [];
      if (productId) seedIds.push(String(productId));
      if (!seedIds.length && mode === 'auto') {
        cartItems.slice(0, 3).forEach(function (it) {
          if (seedIds.indexOf(String(it.product_id)) === -1) seedIds.push(String(it.product_id));
        });
      }
      var seedId = seedIds[0] || null;

      var sourcePromise;
      if (mode === 'auto' && seedIds.length) {
        sourcePromise = Promise.all(seedIds.map(function (sid) {
          var base = '/recommendations/products.json?product_id=' + sid + '&limit=' + Math.max(12, maxItems);
          return fetchJSON(base + '&intent=' + intent)
            .then(function (d) {
              var got = (d && d.products) || [];
              if (got.length >= 2 || intent === 'related') return got;
              return fetchJSON(base + '&intent=related').then(function (d2) {
                return got.concat((d2 && d2.products) || []);
              });
            });
        })).then(function (lists) {
          var recs = [].concat.apply([], lists);
          if (recs.length >= 4 || !handles.length) return recs;
          return fetchCollections(handles, 30).then(function (extra) { return recs.concat(extra); });
        });
      } else {
        sourcePromise = fetchCollections(handles, 30);
      }

      sourcePromise.then(function (products) {
        products = products || [];
      var inCart = {};
      ((cart && cart.items) || []).forEach(function (it) { inCart[it.product_id] = true; });

      // Never recommend service/utility products.
      var EXCLUDED_TYPES = /shipping protection|gift card|insurance|route package/i;

      var seedTypes = {};
      var seedVendors = {};
      if (root.dataset.productType) seedTypes[root.dataset.productType] = true;
      if (root.dataset.productVendor) seedVendors[root.dataset.productVendor] = true;
      cartItems.forEach(function (it) {
        if (it.product_type) seedTypes[it.product_type] = true;
        if (it.vendor) seedVendors[it.vendor] = true;
      });

      var seen = {};
      var pool = [];
      products.forEach(function (p) {
        if (!p || seen[p.id] || inCart[p.id]) return;
        if (String(p.id) === String(seedId || productId)) return;
        seen[p.id] = true;
        var n = normalize(p);
        if (!n) return;
        if (EXCLUDED_TYPES.test(n.productType) || EXCLUDED_TYPES.test(n.title)) return;
        pool.push(n);
      });

      // Relevance tiers: same product type as anything in context, then same
      // vendor, then the rest. Tier 3 only BACKFILLS when relevant matches
      // are scarce (fewer than MIN_RELEVANT) — otherwise oddballs are cut,
      // not just sunk.
      var MIN_RELEVANT = 4;
      var t1 = [], t2 = [], t3 = [];
      pool.forEach(function (n) {
        if (n.productType && seedTypes[n.productType]) t1.push(n);
        else if (n.vendor && seedVendors[n.vendor]) t2.push(n);
        else t3.push(n);
      });
      var items = shuffle(t1).concat(shuffle(t2));
      if (layout === 'compact') {
        // Prime placement: relevant matches only, hide entirely when thin.
        if (items.length < 2) return;
      } else if (items.length < MIN_RELEVANT) {
        items = items.concat(shuffle(t3).slice(0, MIN_RELEVANT - items.length));
      }
      items = items.slice(0, maxItems);
      if (!items.length) return;

      items.forEach(function (item) {
        if (layout === 'compact') {
          var row = document.createElement('div');
          row.className = 'rr-pair';
          var rImg = document.createElement('img');
          rImg.className = 'rr-pair__img';
          rImg.loading = 'lazy';
          rImg.alt = item.title;
          rImg.src = squareImage(item.image) || '';
          row.appendChild(rImg);
          var info = document.createElement('div');
          info.className = 'rr-pair__info';
          var tl = document.createElement('a');
          tl.className = 'rr-pair__title';
          tl.href = item.url;
          tl.textContent = item.title;
          info.appendChild(tl);
          var pr = document.createElement('div');
          pr.className = 'rr-pair__price';
          pr.textContent = money(item.price);
          if (item.compareAt && item.compareAt > item.price) {
            var cm = document.createElement('span');
            cm.className = 'rr-pair__compare';
            cm.textContent = money(item.compareAt);
            pr.appendChild(cm);
          }
          info.appendChild(pr);
          row.appendChild(info);
          var addBtn = document.createElement('button');
          addBtn.type = 'button';
          addBtn.className = 'rr-pair__add';
          addBtn.textContent = 'Add';
          addBtn.addEventListener('click', function () {
            addBtn.disabled = true;
            addBtn.textContent = '…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.variantId, quantity: 1 })
            }).then(function (r) {
              if (!r.ok) throw new Error('add failed');
              addBtn.textContent = '✓';
              if (window.location.pathname.indexOf('/cart') === -1) {
                setTimeout(function () { window.location.href = '/cart'; }, 350);
              }
            }).catch(function () {
              addBtn.disabled = false;
              addBtn.textContent = 'Add';
            });
          });
          row.appendChild(addBtn);
          track.appendChild(row);
          return;
        }
        var card = document.createElement('div');
        card.className = 'rr-card';

        var link = document.createElement('a');
        link.href = item.url;
        var img = document.createElement('img');
        img.className = 'rr-card__img';
        img.loading = 'lazy';
        img.alt = item.title;
        img.src = squareImage(item.image) || '';
        link.appendChild(img);
        card.appendChild(link);

        var titleLink = document.createElement('a');
        titleLink.className = 'rr-card__title';
        titleLink.href = item.url;
        titleLink.textContent = item.title;
        card.appendChild(titleLink);

        if (showStars) {
          var stars = document.createElement('div');
          stars.className = 'rr-card__stars';
          stars.setAttribute('data-rr-handle', item.handle);
          card.appendChild(stars);
        }

        var price = document.createElement('div');
        price.className = 'rr-card__price';
        price.textContent = money(item.price);
        if (item.compareAt && item.compareAt > item.price) {
          var cmp = document.createElement('span');
          cmp.className = 'rr-card__compare';
          cmp.textContent = money(item.compareAt);
          price.appendChild(cmp);
        }
        card.appendChild(price);

        var qtyInput = null;
        if (showQty) {
          var qtyWrap = document.createElement('div');
          qtyWrap.className = 'rr-card__qty';
          var minus = document.createElement('button');
          minus.type = 'button'; minus.textContent = '−';
          minus.className = 'rr-card__qty-btn';
          minus.setAttribute('aria-label', 'Decrease quantity');
          qtyInput = document.createElement('input');
          qtyInput.type = 'text'; qtyInput.inputMode = 'numeric';
          qtyInput.value = '1';
          qtyInput.className = 'rr-card__qty-input';
          qtyInput.setAttribute('aria-label', 'Quantity');
          var plus = document.createElement('button');
          plus.type = 'button'; plus.textContent = '+';
          plus.className = 'rr-card__qty-btn';
          plus.setAttribute('aria-label', 'Increase quantity');
          minus.addEventListener('click', function () {
            qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
          });
          plus.addEventListener('click', function () {
            qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1));
          });
          qtyWrap.appendChild(minus); qtyWrap.appendChild(qtyInput); qtyWrap.appendChild(plus);
          card.appendChild(qtyWrap);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rr-card__add';
        btn.textContent = 'Add to cart';
        btn.addEventListener('click', function () {
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          btn.disabled = true;
          btn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.variantId, quantity: qty })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            btn.textContent = 'Added ✓';
            // Cart page: the cart__main /cart/add sniffer reloads and the ETA
            // machinery re-runs. Product/other pages: go to the cart.
            if (window.location.pathname.indexOf('/cart') === -1) {
              setTimeout(function () { window.location.href = '/cart'; }, 350);
            }
          }).catch(function () {
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          });
        });
        card.appendChild(btn);

        track.appendChild(card);
      });

      root.style.display = 'block';

      // Compact rotator: one row visible at a time, arrows cycle (wrap).
      if (layout === 'compact') {
        var rows = [].slice.call(track.querySelectorAll('.rr-pair'));
        var nav = root.querySelector('.rr-pairs__nav');
        if (rows.length > 1 && nav) {
          var active = 0;
          function showRow(i) {
            active = (i + rows.length) % rows.length;
            rows.forEach(function (r2, k) {
              if (k === active) r2.classList.remove('rr-pair--hidden');
              else r2.classList.add('rr-pair--hidden');
            });
          }
          nav.style.display = '';
          var prevB = nav.querySelector('[data-rr-prev]');
          var nextB = nav.querySelector('[data-rr-next]');
          if (prevB) prevB.addEventListener('click', function () { showRow(active - 1); });
          if (nextB) nextB.addEventListener('click', function () { showRow(active + 1); });
          showRow(0);
        }
      }

      // Judge.me stars for dynamically injected cards: batchRenderBadges
      // takes [{productHandle, badgePlaceholder}] and fetches each rating.
      // Their SDK may load after us — poll briefly. Badges that come back
      // "No reviews" are cleared (the reserved row height keeps alignment).
      if (showStars) {
        var attempts = 0;
        (function renderStars() {
          if (!window.jdgm || typeof window.jdgm.batchRenderBadges !== 'function') {
            // Pages without native Judge.me widgets (e.g. cart) only get the
            // loader stub — pull the core SDK in ourselves, once, using the
            // loader's own URL scheme.
            var j = window.jdgm;
            if (j && typeof j.loadJS === 'function' && !window.__rrJdgmCoreRequested) {
              window.__rrJdgmCoreRequested = true;
              var coreUrl = j.CDN_BASE_URL
                ? j.CDN_BASE_URL + 'shopify_v2.js'
                : (j.CDN_HOST || 'https://cdn.judge.me/') + 'shopify_v2.js';
              try { j.loadJS(coreUrl, function () {}); } catch (e) { /* noop */ }
            }
            if (attempts++ < 20) setTimeout(renderStars, 500);
            return;
          }
          var placeholders = [].slice.call(root.querySelectorAll('.rr-card__stars[data-rr-handle]'));
          try {
            window.jdgm.batchRenderBadges(placeholders.map(function (el) {
              return { productHandle: el.getAttribute('data-rr-handle'), badgePlaceholder: el };
            }));
          } catch (e) { return; }
          setTimeout(function () {
            var empty = placeholders.filter(function (el) { return !el.innerHTML; });
            if (empty.length) {
              try {
                window.jdgm.batchRenderBadges(empty.map(function (el) {
                  return { productHandle: el.getAttribute('data-rr-handle'), badgePlaceholder: el };
                }));
              } catch (e) { /* noop */ }
            }
            setTimeout(function () {
              placeholders.forEach(function (el) {
                if (/no reviews/i.test(el.textContent || '')) el.innerHTML = '';
              });
            }, 2500);
          }, 4000);
        })();
      }

      var prev = root.querySelector('.rr-recs__arrow--prev');
      var next = root.querySelector('.rr-recs__arrow--next');
      function step() {
        var card = track.querySelector('.rr-card');
        return card ? card.getBoundingClientRect().width + 14 : 240;
      }
      function updateArrows() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-raptor-recs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
